import { render, staticRenderFns } from "./avgscoreContrast.vue?vue&type=template&id=6360b2be&scoped=true"
import script from "./avgscoreContrast.vue?vue&type=script&lang=js"
export * from "./avgscoreContrast.vue?vue&type=script&lang=js"
import style0 from "./avgscoreContrast.vue?vue&type=style&index=0&id=6360b2be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6360b2be",
  null
  
)

export default component.exports